<template>
    <div class="w-100">
        <!-- Page title -->
        <div class="row align-items-center mt-1 mb-3">
            <div class="col-9">
                <h2 class="page-title">
                    {{ pageTitle }}
                </h2>
            </div>
        </div>

        <!-- Alert box -->
        <div v-if="this.v$.step[this.currentStep - 1].$error" class="alert alert-danger alert-dismissible" role="alert">
            <div class="d-flex">
                <div>
                    <!-- Download SVG icon from http://tabler-icons.io/i/alert-circle -->
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon alert-icon"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
                        <path d="M12 8v4"></path>
                        <path d="M12 16h.01"></path>
                    </svg>
                </div>
                <div>
                    <span v-if="v$.$errors.length > 1"> Sorry, there are ({{ this.v$.step[this.currentStep - 1].$errors.length }}) errors found please correct the errors to proceed.</span>
                    <span v-if="v$.$errors.length <= 1"> Sorry, there's ({{ this.v$.step[this.currentStep - 1].$errors.length }}) error found please correct the error to proceed.</span>
                </div>
            </div>
            <a class="btn-close" data-bs-dismiss="alert" aria-label="close"></a>
        </div>

        <form id="create-care-plan" action="care-plans/store" class="add-care-plan add-record">

            <div class="card" v-if="currentStep == 1" title="Assessment">
                <div class="card-header">
                    <h3 class="card-title">Assessment</h3>
                </div>
                <div class="card-body">
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Cause of Wound</div>
                                <select
                                    class="form-select"
                                    name="causeOfWound"
                                    v-model="step[0].causeOfWound"
                                    :class="{
                                        'is-invalid': v$.step[0].causeOfWound.$invalid,
                                    }"
                                >
                                    <option value="" disabled>Choose one</option>
                                    <option v-for="option in causeOfWoundOptions" :value="option">
                                        {{ option }}
                                    </option>
                                </select>

                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].causeOfWound.$invalid}">Invalid feedback</div>

                                <div v-if="step[0].causeOfWound === 'Other'" class="mt-3">
                                    <input
                                        type="text"
                                        class="form-control"
                                        name="causeOfWoundOther"
                                        placeholder="Other (please specify)"
                                        v-model="step[0].causeOfWoundOther"
                                        :class="{
                                            'is-invalid': v$.step[0].causeOfWoundOther.$invalid,
                                        }"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        :class="{
                                            'd-block': v$.step[0].causeOfWoundOther.$invalid,
                                        }"
                                    >
                                        Invalid feedback
                                    </div>
                                </div>
                            </div>
                            
                            <div class="mb-3">
                                <div class="form-label">Type of Wound</div>
                                <select
                                    class="form-select"
                                    name="typeOfWound"
                                    v-model="step[0].typeOfWound"
                                    :class="{
                                        'is-invalid': v$.step[0].typeOfWound.$invalid,
                                    }"
                                >
                                    <option value="" disabled>Choose one</option>
                                    <option v-for="option in typeOfWoundOptions" :value="option">
                                        {{ option }}
                                    </option>
                                </select>

                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].typeOfWound.$invalid}">Invalid feedback</div>

                                <div v-if="step[0].typeOfWound === 'Other'" class="mt-3">
                                    <input
                                        type="text"
                                        class="form-control"
                                        name="typeOfWoundOther"
                                        placeholder="Other (please specify)"
                                        v-model="step[0].typeOfWoundOther"
                                        :class="{
                                            'is-invalid': v$.step[0].typeOfWoundOther.$invalid,
                                        }"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        :class="{
                                            'd-block': v$.step[0].typeOfWoundOther.$invalid,
                                        }"
                                    >
                                        Invalid feedback
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Pressure Injury</div>
                                <select
                                    class="form-select"
                                    name="pressureInjury"
                                    v-model="step[0].pressureInjury"
                                    :class="{
                                        'is-invalid': v$.step[0].pressureInjury.$invalid,
                                    }"
                                >
                                    <option value="" disabled>Choose one</option>
                                    <option v-for="option in pressureInjuryOptions" :value="option">
                                        {{ option }}                                        
                                    </option>
                                </select>

                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].pressureInjury.$invalid}">Invalid feedback</div>

                                
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Factors affecting wound healing</div>
                                
                                <multiselect                                    
                                    name="factorsAffectingWoundHealing"
                                    v-model="step[0].factorsAffectingWoundHealing"                                   
                                    :class="{'is-invalid': v$.step[0].factorsAffectingWoundHealing.$invalid}"

                                    :options="this.factorsAffectingWoundHealingOptions" 
                                    :searchable="true" 
                                    :close-on-select="true" 
                                    :show-labels="true" 
                                    :taggable="true"                                    
                                    :multiple="true"

                                    title=""
                                    deselect-label="Deselect"
                                    select-label="Select"
                                    tag-placeholder="Add this as new tag" 
                                    placeholder="Select or add a new factor affecting wound healing"

                                    @tag="addTagFactorsAffectingWoundHealing"
                                ></multiselect>                            
                                                              
                                <div 
                                    class="invalid-feedback"
                                    :class="{'d-block': v$.step[0].factorsAffectingWoundHealing.$invalid}"
                                >
                                    Invalid feedback
                                </div>
                                <div v-if="step[0].factorsAffectingWoundHealing != null && step[0].factorsAffectingWoundHealing.indexOf('Medications') !== -1" class="mt-3">
                                    <input
                                        type="text"
                                        class="form-control"
                                        name="factorsAffectingWoundHealingMedications"
                                        placeholder="Medications (please specify)"
                                        v-model="step[0].factorsAffectingWoundHealingMedications"
                                        :class="{
                                            'is-invalid': v$.step[0].factorsAffectingWoundHealingMedications.$invalid,
                                        }"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        :class="{
                                            'd-block': v$.step[0].factorsAffectingWoundHealingMedications.$invalid,
                                        }"
                                    >
                                        Invalid feedback
                                    </div>
                                </div>
                                <div v-if="step[0].factorsAffectingWoundHealing != null && step[0].factorsAffectingWoundHealing.indexOf('Waterlow Score') !== -1" class="mt-3">
                                    <input
                                        type="text"
                                        class="form-control"
                                        name="factorsAffectingWoundHealingWaterlowScore"
                                        placeholder="Waterlow Score (please specify)"
                                        v-model="step[0].factorsAffectingWoundHealingWaterlowScore"
                                        :class="{
                                            'is-invalid': v$.step[0].factorsAffectingWoundHealingWaterlowScore.$invalid,
                                        }"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        :class="{
                                            'd-block': v$.step[0].factorsAffectingWoundHealingWaterlowScore.$invalid,
                                        }"
                                    >
                                        Invalid feedback
                                    </div>
                                </div>

                            </div>

                            <div class="mb-3">
                                <div class="form-label">Location of Wound</div>
                                <select
                                    class="form-select"
                                    name="locationOfWound"
                                    v-model="step[0].locationOfWound"
                                    :class="{
                                        'is-invalid': v$.step[0].locationOfWound.$invalid,
                                    }"
                                >
                                    <option value="" disabled>Choose one</option>
                                    <option v-for="option in locationOfWoundOptions" :value="option">
                                        {{ option }}                                        
                                    </option>
                                </select>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].locationOfWound.$invalid}">Invalid feedback</div>

                                <div v-if="step[0].locationOfWound === 'Other'" class="mt-3">
                                    <input
                                        type="text"
                                        class="form-control"
                                        name="locationOfWoundOther"
                                        placeholder="Other (please specify)"
                                        v-model="step[0].locationOfWoundOther"
                                        :class="{
                                            'is-invalid': v$.step[0].locationOfWoundOther.$invalid,
                                        }"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        :class="{
                                            'd-block': v$.step[0].locationOfWoundOther.$invalid,
                                        }"
                                    >
                                        Invalid feedback
                                    </div>
                                </div>

                            </div>

                            <div class="mb-3">
                                <div class="form-label">Size of wound</div>                     
                                <input
                                    type="text"
                                    class="form-control mt-2"
                                    name="sizeOfWound"
                                    placeholder="L x W x D"
                                    v-model="step[0].sizeOfWound"
                                    :class="{'is-invalid': v$.step[0].sizeOfWound.$invalid}"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{'d-block': v$.step[0].sizeOfWound.$invalid}"
                                >
                                    Invalid feedback
                                </div>
                            </div>  

            
                        </div>

                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Illustration</div>
                                <p class="text-muted">Click on the area where the wound is located.</p>
                                <img class="mt-3" src="/img/skin-integrity-illustration.jpg" usemap="#skin-integrity-map" width="455" height="422"/>
                                <map name="skin-integrity-map">
                                    <area target="" v-on:click.prevent="step[0].locationOfWound='Ears, RT or LT (E)'" alt="E" title="E" href="" coords="68,42,76,22" shape="rect">
                                    <area target="" v-on:click.prevent="step[0].locationOfWound='Ears, RT or LT (E)'" alt="E" title="E" href="" coords="110,21,117,39" shape="rect">
                                    <area target="" v-on:click.prevent="step[0].locationOfWound='Arms (A)'" alt="A" title="A" href="" coords="40,67,64,158" shape="rect">
                                    <area target="" v-on:click.prevent="step[0].locationOfWound='Arms (A)'" alt="A" title="A" href="" coords="132,65,158,154" shape="rect">
                                    <area target="" v-on:click.prevent="step[0].locationOfWound='Hands, front (HF)'" alt="HF" title="HF" href="" coords="7,197,41,242" shape="rect">
                                    <area target="" v-on:click.prevent="step[0].locationOfWound='Hands, front (HF)'" alt="HF" title="HF" href="" coords="157,194,195,238" shape="rect">
                                    <area target="" v-on:click.prevent="step[0].locationOfWound='Legs (L)'" alt="L" title="L" href="" coords="56,202,141,266" shape="rect">
                                    <area target="" v-on:click.prevent="step[0].locationOfWound='Knees (K)'" alt="K" title="K" href="" coords="65,267,133,293" shape="rect">
                                    <area target="" v-on:click.prevent="step[0].locationOfWound='Shin (SH)'" alt="SH" title="SH" href="" coords="69,294,135,369" shape="rect">
                                    <area target="" v-on:click.prevent="step[0].locationOfWound='Feet (F)'" alt="F" title="F" href="" coords="72,370,141,406" shape="rect">
                                    <area target="" v-on:click.prevent="step[0].locationOfWound='Heels (HE)'" alt="HE" title="HE" href="" coords="313,358,372,417" shape="rect">
                                    <area target="" v-on:click.prevent="step[0].locationOfWound='Legs (L)'" alt="L" title="L" href="" coords="308,208,389,270" shape="rect">
                                    <area target="" v-on:click.prevent="step[0].locationOfWound='Coccyx (CO)'" alt="CO" title="CO" href="" coords="310,157,386,206" shape="rect">
                                    <area target="" v-on:click.prevent="step[0].locationOfWound='Arms (A)'" alt="A" title="A" href="" coords="287,74,312,164" shape="rect">
                                    <area target="" v-on:click.prevent="step[0].locationOfWound='Arms (A)'" alt="A" title="A" href="" coords="387,75,412,156" shape="rect">
                                    <area target="" v-on:click.prevent="step[0].locationOfWound='Shoulders (S)'" alt="S" title="S" href="" coords="314,61,386,112" shape="rect">
                                    <area target="" v-on:click.prevent="step[0].locationOfWound='Back of Head (H)'" alt="H" title="H" href="" coords="333,4,365,56" shape="rect">
                                    <area target="" v-on:click.prevent="step[0].locationOfWound='Ears, RT or LT (E)'" alt="E" title="E" href="" coords="367,23,373,45" shape="rect">
                                    <area target="" v-on:click.prevent="step[0].locationOfWound='Ears, RT or LT (E)'" alt="E" title="E" href="" coords="324,24,332,44" shape="rect">
                                    <area target="" v-on:click.prevent="step[0].locationOfWound='Hands, front (HB)'" alt="HB" title="HB" href="" coords="246,197,284,242" shape="rect">
                                    <area target="" v-on:click.prevent="step[0].locationOfWound='Hands, front (HB)'" alt="HB" title="HB" href="" coords="408,198,441,240" shape="rect">                                    
                                </map>
                            </div>
                            

                         
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="save-btn d-none">Save and continue later</a>
                    </p>                    
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack()" class="p-2 d-block cancel-btn">Cancel</a>
                        <a @click="onClickNext()" class="ms-2 btn btn-primary">Next</a>
                    </p>
                </div>
            </div>

            <div class="card" v-if="currentStep == 2" title="Care Plan Details">
                <div class="card-header">
                    <h3 class="card-title">Care Plan Details</h3>
                </div>

                <div class="card-body">
                    <div class="row gx-5">

                        <div class="col-sm-10 col-md-8 col-xl-6">

                            <div class="mb-3">
                                <div class="form-label">Frequency of Dressing Change</div>
                                <select
                                    class="form-select"
                                    name="frequencyOfDressingChange"
                                    v-model="step[1].frequencyOfDressingChange"
                                    :class="{
                                        'is-invalid': v$.step[1].frequencyOfDressingChange.$invalid,
                                    }">
                                    <option value="" disabled>Choose one</option>
                                    <option v-for="option in frequencyOfDressingChangeOptions" :value="option">
                                        {{ option }}
                                    </option>
                                </select>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[1].frequencyOfDressingChange.$invalid}">Invalid feedback</div>
                            </div>


                            <label class="form-label">Dressing Selection</label>
                            <fieldset class="form-fieldset">
                                <div class="mb-3">
                                    <div class="form-label">Cleaning Solution</div>                     
                                    <input
                                        type="text"
                                        class="form-control mt-2"
                                        name="cleaningSolution"
                                        placeholder="Cleaning Solution"
                                        v-model="step[1].cleaningSolution"
                                        :class="{'is-invalid': v$.step[1].cleaningSolution.$invalid}"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        :class="{
                                            'd-block': v$.step[1].cleaningSolution.$invalid,
                                        }"
                                    >
                                        Invalid feedback
                                    </div>
                                </div>   

                                <div class="mb-3">
                                    <div class="form-label">Primary Dressing</div>                     
                                    <input
                                        type="text"
                                        class="form-control mt-2"
                                        name="primaryDressing"
                                        placeholder="Primary Dressing"
                                        v-model="step[1].primaryDressing"
                                        :class="{'is-invalid': v$.step[1].primaryDressing.$invalid}"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        :class="{
                                            'd-block': v$.step[1].primaryDressing.$invalid,
                                        }"
                                    >
                                        Invalid feedback
                                    </div>
                                </div>   

                                <div class="mb-3">
                                    <div class="form-label">Securing Dressing</div>                     
                                    <input
                                        type="text"
                                        class="form-control mt-2"
                                        name="securingDressing"
                                        placeholder="Securing Dressing"
                                        v-model="step[1].securingDressing"
                                        :class="{'is-invalid': v$.step[1].securingDressing.$invalid}"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        :class="{
                                            'd-block': v$.step[1].securingDressing.$invalid,
                                        }"
                                    >
                                        Invalid feedback
                                    </div>
                                </div>

                                <div class="mb-3">
                                    <div class="form-label">Securing Tape</div>                     
                                    <input
                                        type="text"
                                        class="form-control mt-2"
                                        name="securingTape"
                                        placeholder="Securing Tape"
                                        v-model="step[1].securingTape"
                                        :class="{'is-invalid': v$.step[1].securingTape.$invalid}"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        :class="{
                                            'd-block': v$.step[1].securingTape.$invalid,
                                        }"
                                    >
                                        Invalid feedback
                                    </div>
                                </div>

                                <div class="mb-3">
                                    <div class="form-label">Cream or gel used</div>                     
                                    <input
                                        type="text"
                                        class="form-control mt-2"
                                        name="creamOrGelUsed"
                                        placeholder="Cream or gel used"
                                        v-model="step[1].creamOrGelUsed"
                                        :class="{'is-invalid': v$.step[1].creamOrGelUsed.$invalid}"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        :class="{
                                            'd-block': v$.step[1].creamOrGelUsed.$invalid,
                                        }"
                                    >
                                        Invalid feedback
                                    </div>
                                </div>

                                <div class="mb-3">
                                    <div class="form-label">Extras</div>                     
                                    <input
                                        type="text"
                                        class="form-control mt-2"
                                        name="extras"
                                        placeholder="Extras"
                                        v-model="step[1].extras"
                                        :class="{'is-invalid': v$.step[1].extras.$invalid}"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        :class="{
                                            'd-block': v$.step[1].extras.$invalid,
                                        }"
                                    >
                                        Invalid feedback
                                    </div>
                                </div>
                                
                            </fieldset>
                        </div>

                        <div class="col-sm-10 col-md-8 col-xl-6">                            
                            
                            <div class="mb-3">
                                <div class="form-label">Start date</div>
                                <input
                                    type="date"
                                    class="form-control  w-75"
                                    name="startDate"
                                    placeholder=""
                                    v-model="step[1].startDate"
                                    :class="{'is-invalid': v$.step[1].startDate.$invalid}"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[1].startDate.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                    
                            <div class="mb-3">
                                <div class="form-label">Next Review (Plan Expiration)</div>
                                <input
                                    type="date"
                                    class="form-control  w-75"
                                    name="expirationDate"
                                    placeholder=""
                                    v-model="step[1].expirationDate"
                                    :class="{'is-invalid': v$.step[1].expirationDate.$invalid}"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[1].expirationDate.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Signature</div>                     
                                <input
                                    type="text"
                                    class="form-control w-75 mt-2"
                                    name="registeredNurseSignature"
                                    placeholder="Enter your full name"
                                    v-model="step[1].registeredNurseSignature"
                                    :class="{'is-invalid': v$.step[1].registeredNurseSignature.$invalid}"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[1].registeredNurseSignature.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>                         

                        </div>

                    </div>

                </div>
                
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="save-btn" id="last-save-btn">Save and continue later</a>
                    </p>
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack()" href="#" class="p-2 mx-3 d-block back-btn" id="last-back-btn">Back</a>
                        <a @click="onClickNext()" class="ml-5 btn btn-primary" id="submit-btn">Finish</a>
                    </p>
                </div>
                
            </div>

        </form>
    </div>
</template>

<script>
import {alpha, alphaNum, email, integer, required, requiredIf, minLength, maxLength, minValue, maxValue, helpers} from "@vuelidate/validators";
import {useVuelidate} from "@vuelidate/core";
import Multiselect from 'vue-multiselect';
import moment from 'moment';

// Custom Validators
const inArray = (array) => (value) => array.includes(value) || !helpers.req(value);
const isDateFormat = (value) => value.match("^$|((?:[0-9]{2})?[0-9]{2})-(1[0-2]|0?[1-9])-(3[01]|[12][0-9]|0?[1-9])") || !helpers.req(value);
const isTimeFormat = (value) => value.match("^$|^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$") || !helpers.req(value);
const isTextWithSpace = (value) => value.match("^[a-zA-Z0-9_ \s\'\"]*$") || !helpers.req(value);


export default {
    name: "woundCarePlanCreateComponent",
    props: ["progressBar", "pageTitle", "residentId", "userId", "carePlan", "operation", "cancelUrl"], // vue can read kebab props as camel cased vars
    components: { Multiselect },
    setup() {
        return {v$: useVuelidate()};
    },
    data() {
       
        // If copying, assign care plan object to a variable
        if (this.operation == 'store') {
            var carePlanObject = {};                                                      
            var endpointToUse = location.protocol + "//" + window.location.host + "/api/care-plans/" + process.env.MIX_API_KEY; 
        }
        else if (this.operation == 'update') {         
            var carePlanObject = JSON.parse(this.carePlan);            
            carePlanObject['wound_care_plan'] = JSON.parse(carePlanObject['wound_care_plan']);
            var endpointToUse = location.protocol + "//" + window.location.host + "/api/care-plans/" + carePlanObject.id + '/' + process.env.MIX_API_KEY; 
        }
        else if (this.operation == 'copy') {
            var carePlanObject = JSON.parse(this.carePlan);
            carePlanObject['wound_care_plan'] = JSON.parse(carePlanObject['wound_care_plan']);
            var endpointToUse = location.protocol + "//" + window.location.host + "/api/care-plans/" + process.env.MIX_API_KEY; 
            console.log(carePlanObject);
        }

        // Returs empty string when object doesn't exist 
        // options - array | string
        function returnValueFromObject(fieldName, parent, defaultValue = "") {      
            // Editing
            if (!_.isEmpty(carePlanObject)) { 
                if (fieldName == 'starts_at' || fieldName == 'expires_at') {
                    return carePlanObject[fieldName] != null ? carePlanObject[fieldName].split(' ')[0] : defaultValue;                    
                } else {
                    if (parent != null){
                        return carePlanObject[parent][fieldName] ?? defaultValue;
                    } else {
                        return carePlanObject[fieldName] ?? defaultValue;               
                    }
                }
            } else {
                return defaultValue;
            }
        }


        return {
            currentStep: 1, 
            maxStep: 2,
            percentageComplete: 0,
            errors: 0,
            currentStepSaved: 0,
            trueFalseOptions: [true, false],
            causeOfWoundOptions: ['Trauma','Pressure','Surgery', 'Infection', 'Allergy', 'Other'],
            typeOfWoundOptions: ['Simple','Complex','Chronic', 'Laceration', 'Skin tear', 'Ulcerated', 'Cavity', 'Blister', 'Burn', 'Other'],
            pressureInjuryOptions: ['Grade 1','Grade 2','Grade 3', 'Grade 4', 'Unstageable'],
            factorsAffectingWoundHealingOptions: ['Age over 70','Poor Fluid and Nutritional Intake','Diabetes', 'Obesity', 'Immobility', 'Infection', 'Malignancy', 'Smoking', 'Medications', 'Incontinence', 'Waterlow Score'],
            locationOfWoundOptions: ['Ears, RT or LT (E)','Shoulders (S)','Arms (A)', 'Back of Head (H)', 'Coccyx (CO)', 'Legs (L)', 'Shin (SH)', 'Knees (K)', 'Feet (F)', 'Heels (HE)', 'Hands, front (HF)', 'Hands, back (HB)', 'Other'],
            
            frequencyOfDressingChangeOptions: ['Daily','Every Two Days','Every Three Days', 'Weekly'],
            host: document.location.origin,
            endpoint: endpointToUse,
            step: [       
                // Step 1 - Assessment
                {                       
                    causeOfWound: returnValueFromObject('causeOfWound','wound_care_plan'),
                    causeOfWoundOther: returnValueFromObject('causeOfWoundOther','wound_care_plan'),
                    typeOfWound: returnValueFromObject('typeOfWound','wound_care_plan'),
                    typeOfWoundOther: returnValueFromObject('typeOfWoundOther','wound_care_plan'),
                    pressureInjury: returnValueFromObject('pressureInjury','wound_care_plan'),
                    factorsAffectingWoundHealing: returnValueFromObject('factorsAffectingWoundHealing','wound_care_plan'),
                    factorsAffectingWoundHealingMedications: returnValueFromObject('factorsAffectingWoundHealingMedications','wound_care_plan'),
                    factorsAffectingWoundHealingWaterlowScore: returnValueFromObject('factorsAffectingWoundHealingWaterlowScore','wound_care_plan'),
                    locationOfWound: returnValueFromObject('locationOfWound','wound_care_plan'),
                    locationOfWoundOther: returnValueFromObject('locationOfWoundOther','wound_care_plan'),
                    sizeOfWound: returnValueFromObject('sizeOfWound','wound_care_plan'),
                },
                // Step 2 - Care Plan Details
                {   frequencyOfDressingChange: returnValueFromObject('frequencyOfDressingChange','wound_care_plan'),
                    cleaningSolution: returnValueFromObject('cleaningSolution','wound_care_plan'),
                    primaryDressing: returnValueFromObject('primaryDressing','wound_care_plan'),
                    securingDressing: returnValueFromObject('securingDressing','wound_care_plan'),
                    securingTape: returnValueFromObject('securingTape','wound_care_plan'),
                    creamOrGelUsed: returnValueFromObject('creamOrGelUsed','wound_care_plan'), 
                    extras: returnValueFromObject('extras','wound_care_plan'),
                    startDate: returnValueFromObject('starts_at'),
                    expirationDate: returnValueFromObject('expires_at'),
                    registeredNurseSignature: returnValueFromObject('registered_nurse_signature'),                  
                },
            ],
        };
    },
    validations() {
        const dateType = {
            required, 
            isDateFormat, 
            $lazy: true, 
            $autoDirty: true
        };
        
        const timeType = {
            required, 
            isTimeFormat, 
            $lazy: true, 
            $autoDirty: true
        };

        // TEXT TYPES: default: 191, mid:500, long:1000
        function text(minimum = 3,maximum = 191, isRequired = false) {
            var rule = {
                required,
                isTextWithSpace,
                minLength: minLength(minimum),
                maxLength: maxLength(maximum),
                $lazy: true,
                $autoDirty: true,
            };

            if (!isRequired) {
                rule = Object.assign({}, rule);
                delete rule['required']
            }
            return rule;
        }

        // ARRAY TYPES        
        function inOptions(options, isRequired = false) {
            var rule = {
                required,
                inOptions: inArray(options),
                $lazy: true,
                $autoDirty: true,
            };

            if (!isRequired) {
                rule = Object.assign({}, rule);
                delete rule['required']
            }
            return rule;
        }
        
        // Use for types with no 'required' parameter
        function notRequired(type) {
            var validations = Object.assign({}, type);                
            delete validations['required'];
            
            return validations;
        };

        return {
            step: [
                // Step 1 - Assessment
                {
                    causeOfWound: inOptions(this.causeOfWoundOptions), 
                    causeOfWoundOther: text(),
                    typeOfWound: inOptions(this.typeOfWoundOptions),
                    typeOfWoundOther: text(),
                    pressureInjury: inOptions(this.pressureInjuryOptions),
                    factorsAffectingWoundHealing: {      
                        // $each: helpers.forEach({ //TODO: figure out why we can't validate each entry
                        //     minLength: minLength(3),
                        //     required
                        // }),
                        $lazy: true,
                        $autoDirty: true,
                    },
                    factorsAffectingWoundHealingMedications: text(),
                    factorsAffectingWoundHealingWaterlowScore: text(1),
                    locationOfWound: inOptions(this.locationOfWoundOptions),
                    locationOfWoundOther: text(),
                    sizeOfWound: text(),
                },
                // Step 2 - Care Plan Details
                {  
                    frequencyOfDressingChange: inOptions(this.frequencyOfDressingChangeOptions),
                    cleaningSolution: text(),
                    primaryDressing: text(),
                    securingDressing: text(),
                    securingTape: text(),
                    creamOrGelUsed: text(),
                    extras: text(),
                    startDate: dateType,
                    expirationDate: dateType,
                    registeredNurseSignature: text(),                 
                }, 
                
            ],
        };
    },

    computed: {},

    methods: {
        onClickNext: function () {   
            
            // Validate fields on current step
            this.v$.step[this.currentStep - 1].$touch();  
            
            // if there are no errors in the current step
            if (!this.v$.step[this.currentStep - 1].$error) {
         
                // All steps
                if (this.currentStep < this.maxStep) {                           
                    // Proceed to next step
                    this.currentStep++;

                // Final step
                } else if (this.currentStep == this.maxStep) {                    
                    
                    // Initialize alerts and toast notifications for displaying message  
                    const toastError = Swal.mixin({          
                            toast: true,                
                            position: 'top-end', 
                            showConfirmButton: true, 
                        });  
                    const alertSuccess = Swal.mixin({                          
                            position: 'center', 
                            showConfirmButton: true, 
                            timer: 3000,
                            timerProgressBar: true,
                        });  

                    // Show button spinner
                    document.getElementById('submit-btn').innerHTML  = '<i class="fa fa-circle-notch fa-spin"></i>';
                    document.getElementById('submit-btn').disabled  = true;
                    document.getElementById('last-back-btn').setAttribute('style', 'display:none !important');
                    document.getElementById('last-save-btn').setAttribute('style', 'display:none !important');

                    var formData = {};
                    
                    // Loop through all steps
                    for(let i=0; i < this.maxStep; i++){
                        for ( const [key,value] of Object.entries( this.step[i] ) ) {   
                            formData[key] = value;                     
                        }                       
                    }

                    console.log(formData, this.residentId, this.operation);

                    // Add residentID and userID
                    formData['residentID'] = this.residentId;
                    formData['userID'] = this.userId;
                    formData['type'] = "Wound";
                    

                    if (this.operation == 'store') {
                        this.createCarePlan(formData, toastError, alertSuccess);
                    }
                    else if(this.operation == 'update') {
                        formData['updateType'] = 'update';
                        this.updateCarePlan(formData, toastError, alertSuccess);
                    }
                    else if(this.operation == 'copy') {
                        formData['updateType'] = 'copy';
                        this.createCarePlan(formData, toastError, alertSuccess);
                    }
                }
                this.percentageComplete = Math.round((this.currentStep / this.maxStep) * 100);
            }
        },
        onClickBack: function () {
           
            if (this.currentStep > 1) {
                this.currentStep--;
            }
            else {
                window.location = this.cancelUrl;
            }
         
            this.percentageComplete = Math.round((this.currentStep / this.maxStep) * 100);
        },

        addTagFactorsAffectingWoundHealing (newTag) {            
            this.factorsAffectingWoundHealingOptions.push(newTag)
            this.step[0].factorsAffectingWoundHealing.push(newTag)          
        },

        createCarePlan: function(formData, toastError, alertSuccess) {
    
            // Call the store endpoint
            axios.post(this.endpoint, formData)
                .then((response) => {
                    if(response.data.error == 403){                                
                        console.log('Bad Request');
                        console.log(response.data);
                        
                        // Show bad request toast message. This error occurs when the input fields are not in the expected format
                        toastError.fire({ 
                            type: 'warning', 
                            title: 'The input fields are malformed and cant be processed.' 
                        }); 
                    } else {
                        if(response.data.id == null){
                            console.log('Validation Error');
                            console.log(response.data);
                            
                            // Show validation toast message. This error only occurs when the javascript validation is bypassed and the API endpoint returned validation error instead of the resident object
                            toastError.fire({ 
                                type: 'warning', 
                                title: 'There are validation errors found on the form.'
                            });                             
                        }
                        else{
                            console.log("Success");
                            console.log(response.data);

                            // Show success alert message and redirect to the index page. This occurs when the form submission is successful and the resident object was added/updated
                            this.formSuccess = true;
                            window.residentId = this.residentId;

                            alertSuccess.fire({
                                title: "Success!",
                                text: "The wound care plan has been added.",
                                icon: "success",                           
                            }).then(function(){
                                window.location = "/care-plans/"+response.data.id+"/edit-photo";
                            }); 
                        }
                    }                                        
                    
                })
                .catch((err) => {                            
                    console.log("Endpoint Error!");
                    console.log(err.response);
                    toastError.fire({ type: 'warning', title: 'Sorry, request failed to submit.' }); // this error occurs when endpoint is wrong
                })     
        },

        updateCarePlan: function(formData, toastError, alertSuccess) {
            
            // Call the update endpoint
            axios.put(this.endpoint, formData)
                .then((response) => {
                    if(response.data.error == 403){                                
                        console.log('Bad Request');
                        console.log(response.data);
                        
                        // Show bad request toast message. This error occurs when the input fields are not in the expected format
                        toastError.fire({ 
                            type: 'warning', 
                            title: 'The input fields are malformed and cant be processed.' 
                        }); 
                    } else {
                        if(response.data.id == null){
                            console.log('Validation Error');
                            console.log(response.data);
                            
                            // Show validation toast message. This error only occurs when the javascript validation is bypassed and the API endpoint returned validation error instead of the resident object
                            toastError.fire({ 
                                type: 'warning', 
                                title: 'There are validation errors found on the form.'
                            });                             
                        }
                        else{
                            console.log("Success");
                            console.log(response.data);

                            // Show success alert message and redirect to the index page. This occurs when the form submission is successful and the resident object was added/updated
                            this.formSuccess = true;
                            window.residentId = this.residentId;

                            alertSuccess.fire({
                                title: "Success!",
                                text: "The wound care plan has been updated.",
                                icon: "success",                           
                            }).then(function(){
                                window.location = "/residents/"+window.residentId+"/care-plans?type=Wound";
                            }); 
                        }
                    }                                        
                    
                })
                .catch((err) => {                            
                    console.log("Endpoint Error!");
                    console.log(err.response);
                    toastError.fire({ type: 'error', title: 'Sorry, request failed to submit.' }); // this error occurs when endpoint is wrong
                })
        }                
    },
};
</script>
